import React from 'react';
import { useIntl } from 'react-intl';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const PagesStepper = function DotsMobileStepper({
  currentStep,
  handleChangeStep, //function that accepts + or - number of steps
  max, //number of steps
  variant = 'dots',
  nextText = null,
  backText = null,
  submitStep = false,
  onCancel = null, //what the back button does on the first step; without it the button is off
}) {
  const intl = useIntl();

  return (
    <MobileStepper
      variant={variant}
      steps={max}
      position="bottom"
      activeStep={currentStep}
      sx={{
        position: 'sticky',
        width: '100%',
        backgroundColor: 'transparent',
        // The two buttons share the leftover space equally so the dots land in
        // the middle of the row. MobileStepper spaces its three children apart,
        // which centres the dots only when both labels are the same width.
        '& > .MuiButton-root': {
          flex: '1 1 0',
          minWidth: 0,
        },
        '& > .MuiButton-root:first-of-type': {
          justifyContent: 'flex-start',
        },
        '& > .MuiButton-root:last-of-type': {
          justifyContent: 'flex-end',
        },
        // One step has no progress to show: a bar stuck at 100% reads as a loading bar. Hidden,
        // not removed, so the buttons keep their places.
        ...(max < 2 && {
          '& .MuiMobileStepper-progress, & .MuiMobileStepper-dots': {
            visibility: 'hidden',
          },
        }),
      }}
      nextButton={
        <Button
          type={submitStep ? 'submit' : 'button'}
          variant={submitStep ? 'contained' : 'text'}
          onClick={(e) => {
            if (!submitStep) {
              e.preventDefault();
              handleChangeStep(+1);
            }
          }}
          disabled={!submitStep && currentStep === max - 1}
        >
          {nextText || intl.messages.NEXT}
          {nextText ? null : <KeyboardArrowRight />}
        </Button>
      }
      backButton={
        <Button
          onClick={(e) =>
            currentStep === 0 ? onCancel?.(e) : handleChangeStep(-1)
          }
          disabled={currentStep === 0 && !onCancel}
          variant="text"
        >
          {backText ? null : <KeyboardArrowLeft />}
          {backText || intl.messages.BACK}
        </Button>
      }
    />
  );
};

export default PagesStepper;
